import React, {ReactElement, useEffect, useState} from "react";
import {FormGenContentItem, FormGenLayoutSource} from "./FormGenContainer";
import {StyledBoxColumn, StyledBoxRow} from "./StyledComponents";
import {MenuItem, Select} from "@mui/material";
import {DATE_RANGE_TYPE_KTS, DateRangeType} from "./types";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";

function RangeValue(type: DateRangeType): number[] {
  if (type === DateRangeType.CUSTOM) {
    return undefined;
  }
  const now = dayjs(Date.now());
  let start = dayjs(now).set('h', 0).set('m', 0).set('s', 0);
  let end = start.add(1, 'd');
  switch (type) {
    default:
    case DateRangeType.TODAY:
      // Nothing.
      break;
    case DateRangeType.WEEK:
      start = start.subtract(start.day(), 'd');
      break;
    case DateRangeType.MONTH:
      start = start.subtract(1, 'M');
      break;
    case DateRangeType.YEAR:
      start = start.subtract(1, 'y');
      break;
    case DateRangeType.YEAR_TO_DATE:
      start = start.startOf('y');
      break;
    case DateRangeType.YESTERDAY:
      start = start.subtract(1, 'd');
      end = start.add(1, 'd');
      break;
    case DateRangeType.LAST_WEEK:
      start = start.add(-start.day(), 'd').subtract(1, 'w');
      end = start.add(1, 'w');
      break;
    case DateRangeType.LAST_MONTH:
      start = start.subtract(start.date() - 1, 'd').subtract(1, 'M');
      end = start.add(1, 'M');
      break;
    case DateRangeType.LAST_YEAR:
      start = start.subtract(start.dayOfYear() - 1, 'd').subtract(1, 'y');
      end = start.add(1, 'y');
      break;
  }
  end = end.subtract(1, 's');
  return [start.toDate().getTime(), end.toDate().getTime()];
}

export function FormGenDateRange(props: {
  contentItem: FormGenContentItem,
  disabled?: boolean,
  index: number,
  source: FormGenLayoutSource,
}): ReactElement {
  const [value, setValue] = useState<number[]>(props.source.getValue(props.contentItem));
  let dateRangeDefaultType = DateRangeType.CUSTOM;
  if (!value) {
    dateRangeDefaultType = props.contentItem.metadata.dateRangeDefaultType || DateRangeType.TODAY;
  }
  const [dateRangeType, setDateRangeType] = useState<DateRangeType>(dateRangeDefaultType);
  useEffect(() => {
    if (dateRangeType !== DateRangeType.CUSTOM) {
      setValue(RangeValue(dateRangeType));
    }
  }, [dateRangeType]);
  useEffect(() => {
    props.source.setValue(props.contentItem, value);
  }, [value]);
  return <StyledBoxColumn>
    <Select size="small" value={dateRangeType} onChange={(event: any) => {
      setDateRangeType(event.target.value);
    }}>
      {DATE_RANGE_TYPE_KTS.values.map(value => <MenuItem value={value.key}>{value.text}</MenuItem>)}
    </Select>
    <StyledBoxRow>
      <DesktopDatePicker
        label={"From"}
        disabled={dateRangeType !== DateRangeType.CUSTOM}
        slotProps={{textField: {size: "small"}}}
        // sx={{minWidth: PAGE_FRAGMENT_HALF_WIDTH}}
        value={dayjs(value?.[0])}
        onChange={date => {
          const newValue = [value?.[0], value?.[1]];
          newValue[0] = date.toDate().getTime();
          setValue(newValue);
        }}/>
      <DesktopDatePicker
        label={"To"}
        disabled={dateRangeType !== DateRangeType.CUSTOM}
        slotProps={{textField: {size: "small"}}}
        // sx={{minWidth: PAGE_FRAGMENT_HALF_WIDTH}}
        value={dayjs(value?.[1])}
        onChange={date => {
          const newValue = [value?.[0], value?.[1]];
          newValue[1] = date.toDate().getTime();
          setValue(newValue);
        }}/>
    </StyledBoxRow>
  </StyledBoxColumn>
}